import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography } from '@material-ui/core';

import { useFormContext } from 'react-hook-form';

import { Add, AddBox } from '@material-ui/icons';
import { AutocompleteForm, FormDropZone } from 'components';

const campoRequerido = { required: { value: true, message: 'Campo requerido' } };
const FormNuevaMA = ({ usuario }) => {
    const { register, errors, control } = useFormContext();
    return (
        <Grid container spacing={2}>
            {/* <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="TIPO DE SOLICITUD"
                    select
                    SelectProps={{ native: true }}
                    name="tipo_solicitud"
                    inputRef={register(campoRequerido)}
                    error={errors.tipo_solicitud}
                    helperText={errors.tipo_solicitud?.message}
                >
                    <option value=""></option>
                    <option value="1">MEJORA</option>
                    <option value="2">INCIDENCIA</option>
                    <option value="3">NUEVO MÓDULO</option>
                </TextField>
            </Grid> */}
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="PRIORIDAD"
                    select
                    SelectProps={{ native: true }}
                    name="idprioridad"
                    inputRef={register(campoRequerido)}
                    error={errors.idprioridad}
                    helperText={errors.idprioridad?.message}
                >
                    <option value=""></option>
                    <option value="1">ALTA</option>
                    <option value="2">MEDIA</option>
                    <option value="3">BAJA</option>
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="TÍTULO"
                    name="titulo"
                    inputRef={register(campoRequerido)}
                    error={errors.titulo}
                    helperText={errors.titulo?.message}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    label="SOLICITUD"
                    name="problematica"
                    inputRef={register(campoRequerido)}
                    error={errors.problematica}
                    helperText={errors.problematica?.message}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    minRows={3}
                    multiline
                    label="DESCRIPCIÓN DE LA SOLICITUD"
                    name="desc_malcance"
                    inputRef={register(campoRequerido)}
                    error={errors.desc_solicitud}
                    helperText={errors.desc_solicitud?.message}
                />
            </Grid>
            <Grid item xs={12}>
                <FormDropZone
                    rules = {{}}
                    name = "filefield"
                    control = {control}
                    label = "control"
                />
            </Grid>          
        </Grid>
    );
};

export default FormNuevaMA;
